import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getDepositAccounts } from 'services/WalletsService'
import { DepositBankAccount } from 'types/BankAccountsDetails'
import { QueryMetaType } from 'types/reactQuery'
import { Currencies, ErrorAPI } from 'types/types'

export const useDepositAccountsQuery = (walletId: string, enabled = false) => {
  const meta: QueryMetaType = {
    errorAdditionalData: { walletId },
  }

  return useQuery<DepositBankAccount[], { data: ErrorAPI }>({
    queryKey: reactQueryKeys.depositAccounts(walletId),
    queryFn: () => getDepositAccounts(walletId),
    enabled,
    meta,
    select: (data: DepositBankAccount[]) => {
      return data?.filter(bankAccount => {
        if (bankAccount?.currency !== Currencies.GBP) return true
        if (!bankAccount?.accountNumberFormat) return true

        if (!bankAccount?.isSwift && bankAccount?.accountNumberFormat === 'SCAN') return true
        if (bankAccount?.isSwift && bankAccount?.accountNumberFormat === 'SWIFT') return true
        return false
      })
    },
  })
}
